export default __webpack_public_path__ + "static/media/share.2c5ca71c.svg";